import { hasVerifiedBadge, VerifiedBadge } from '@/components/badges/VerifiedBadge'
import { UserIconFilled } from '@/components/icons'
import { BracketPayment, BracketPlayer, ClubMember, Player } from '@/types'
import { HTMLAttributes } from 'react'

type Props = {
  player: Player | ClubMember | BracketPayment | BracketPlayer
} & HTMLAttributes<HTMLDivElement>

export const PlayerInfoSection = ({ player, className = '', ...props }: Props) => {
  const badges = player && 'badges' in player ? player.badges : undefined
  return (
    <div className={`flex gap-x-2 ${className}`} {...props}>
      {player?.imageUrl ? (
        <img src={player?.imageUrl} className="rounded-full w-10 h-10" alt="avatar" />
      ) : (
        <UserIconFilled className="w-10 h-10 text-primary-500" />
      )}
      <div className="flex flex-col">
        <div className="flex items-center gap-x-1 text-sm font-semibold">
          {hasVerifiedBadge(badges) && <VerifiedBadge />}
          <span className="text-navy-900">{player?.fullName || player?.fullname}</span>
          <span className="text-navy-900 text-opacity-50 hidden md:inline">
            {player?.referralCode || player?.duprId}
          </span>
        </div>
        <span className="text-navy-900 text-sm font-semibold text-opacity-50 md:hidden inline">
          {player?.referralCode || player?.duprId}
        </span>
        <span className="text-xs font-normal text-navy-900 text-opacity-80">{player?.shortAddress}</span>
        <span className="text-xs font-normal text-navy-900 text-opacity-60">
          {player?.age}
          {player?.gender ? ` • ${player?.gender[0]}` : ''}
        </span>
      </div>
    </div>
  )
}
